<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.51 12l6.29-6.29a1 1 0 000-1.42 1 1 0 00-1.41 0l-6.3 6.3-6.29-6.3a1 1 0 00-1.41 0 1 1 0 000 1.42L10.68 12l-6.29 6.29a1 1 0 00.7 1.71 1 1 0 00.71-.29l6.29-6.3 6.3 6.3a1 1 0 00.7.29 1 1 0 00.71-.29 1 1 0 000-1.42z"/></svg>